// extracted by mini-css-extract-plugin
module.exports = {"scrollCarda":"ScrollCard_scrollCarda__7m9sB","scrollCard":"ScrollCard_scrollCard__ozeYw","ani-op":"ScrollCard_ani-op__AgB4y"};